import type { MessageReaction } from '../../types/chat';
import { groupReactions } from '../../types/chat';

interface MessageReactionsProps {
  reactions: MessageReaction[];
  currentPseudo: string;
  onReact: (emoji: string) => void;
}

export default function MessageReactions({
  reactions,
  currentPseudo,
  onReact,
}: MessageReactionsProps) {
  if (reactions.length === 0) return null;

  const groups = groupReactions(reactions, currentPseudo);

  return (
    <div className="message-reactions">
      {groups.map((group) => (
        <button
          key={group.emoji}
          type="button"
          className="message-reaction-chip"
          onClick={() => onReact(group.emoji)}
          title={group.users.join(', ')}
          aria-label={`${group.emoji} ${group.count} réaction${group.count > 1 ? 's' : ''}`}
        >
          <span className="message-reaction-emoji">{group.emoji}</span>
          {group.count > 1 && (
            <span className="message-reaction-count">{group.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
